let promise: Promise<void> | null = null

export function loadGoogleMaps(): Promise<void> {
  if ((window as any).google?.maps) return Promise.resolve()

  if (!promise) {
    promise = new Promise<void>((resolve, reject) => {
      const key = process.env.REACT_APP_GOOGLE_PLACES_KEY
      if (!key) {
        reject(new Error("REACT_APP_GOOGLE_PLACES_KEY is not set"))
        return
      }

      const script = document.createElement("script")
      script.src = `https://maps.googleapis.com/maps/api/js?key=${key}&libraries=places`
      script.async = true
      script.onload = () => resolve()
      script.onerror = () => {
        promise = null
        reject(new Error("Failed to load Google Maps"))
      }
      document.head.appendChild(script)
    })
  }

  return promise
}
